module.exports = __webpack_public_path__ + "static/media/thumbnail-gephaz_acelszerkezeti_es_felujitasi_munkai.a5d7b35d.jpg";